import { useState, useRef, useMemo } from "react";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";

const CreateComparisonModal = (props) => {
  const { onCreate, onCancel, ...rest } = props;
  const [touched, setTouched] = useState(false);
  const [name, setName] = useState("");
  const nameError = useMemo(() => {
    if (!touched) return null;
    if (!(name.trim().length > 0)) return "Name is required";
    return null;
  }, [name, touched]);
  const nameRef = useRef(null);
  const handleNameChanged = (event) => {
    setName(event.target.value);
  };
  const canSubmit = () => name.trim().length >= 1;
  const handleSubmit = (event) => {
    event.preventDefault();
    setTouched(true);
    if (!canSubmit()) return;
    onCreate(name);
  };
  const handleShow = () => {
    const currentDateTime = new Date()
      .toISOString()
      .slice(0, 16)
      .replace("T", " ");
    setName(`Comparison ${currentDateTime}`);
  };
  const handleEntered = () => {
    const el = nameRef.current;
    if (el) {
      el.focus();
      el.select();
    }
  };
  return (
    <Modal
      onShow={handleShow}
      onEntered={handleEntered}
      onHide={onCancel}
      {...rest}
    >
      <Form onSubmit={handleSubmit}>
        <Modal.Header>
          <Modal.Title>Create Comparison</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group controlId="name">
            <Form.Label>Name for the new comparison:</Form.Label>
            <Form.Control
              type="text"
              value={name}
              onChange={handleNameChanged}
              ref={nameRef}
              autoFocus
              isInvalid={!!nameError}
            />
            <Form.Control.Feedback type="invalid">
              {nameError}
            </Form.Control.Feedback>
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={onCancel}>
            Cancel
          </Button>
          <Button variant="primary" type="submit">
            Create
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default CreateComparisonModal;
